import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    admin: false,
    token: getToken(),
    name: '',
    nickName: '',
    phonenumber: '',
    userId: '',
    tenantId: '',
    tenantType: null,
    avatar: '',
    roles: [],
    permissions: [],
    tenants: [],
    dept: {},
    postIds: [],
    userDataScope: '' // 用户数据权限范围（10：所有数据权限；20：仅本人数据权限 30：有部门数据权限）
  },

  mutations: {
    SET_IS_ADMIN: (state, admin) => {
      state.admin = admin
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId
    },
    SET_TENANT_ID: (state, tenantId) => {
      state.tenantId = tenantId
    },
    SET_TENANT_TYPE: (state, tenantType) => {
      state.tenantType = tenantType
    },
    SET_NICKNAME: (state, nickName) => {
      state.nickName = nickName
    },
    SET_PHONENUMBER: (state, phonenumber) => {
      state.phonenumber = phonenumber
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_TENANTS: (state, tenants) => {
      state.tenants = tenants
    },
    SET_DEPT: (state, dept) => {
      state.dept = dept
    },
    SET_USER_DATA_SCOPE: (state, userDataScope) => {
      state.userDataScope = userDataScope
    },
    SET_USER_POST: (state, post) => {
      state.postIds = post
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      const code = userInfo.code
      const uuid = userInfo.uuid
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid).then(res => {
          setToken(res.token)
          commit('SET_TOKEN', res.token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(res => {
          if (!res) {
            return
          }
          const user = res.user
          const avatar = user.avatar;
          if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', res.roles)
            commit('SET_PERMISSIONS', res.permissions)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          commit('SET_IS_ADMIN', user.admin)
          commit('SET_TENANTS', res.tenants)
          commit('SET_TENANT_ID', user.tenantId)
          commit('SET_TENANT_TYPE', res.tenantType)
          commit('SET_USER_ID', user.userId)
          commit('SET_NICKNAME', user.nickName)
          commit('SET_PHONENUMBER', user.phonenumber)
          commit('SET_AVATAR', avatar)
          commit('SET_DEPT', user.dept)
          commit('SET_USER_DATA_SCOPE', user.userDataScope)
          commit('SET_USER_POST', user.postIds)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          commit('SET_DEPT', {})
          commit('SET_USER_DATA_SCOPE', '')
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
